export default __webpack_public_path__ + "df4fee0b769974594cfdaf0244235e02.png";